var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-rdh-c88": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "#013d50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M10 3.54545C10 4.95127 8.86036 6.09091 7.45455 6.09091C6.04873 6.09091 4.90909 4.95127 4.90909 3.54545C4.90909 2.13964 6.04873 1 7.45455 1C8.86036 1 10 2.13964 10 3.54545Z",
    stroke: "#013d50",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M7.45455 8C4.99437 8 3 9.99437 3 12.4545H11.9091C11.9091 9.99437 9.91472 8 7.45455 8Z",
    stroke: "#013d50",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubPartner);
export default __webpack_public_path__ + "static/media/SubPartner.23b2716709082be951be4c5a1b4e11fb.svg";
export { ForwardRef as ReactComponent };